const UserInfoKey = "UserInfoKey";
const PermissionKey = "PermissionKey";
const TokenKey = "TokenKey";
const RefreshTokenKey = "RefreshTokenKey"
const UserId = "userId";
const MenuList = "menuList";
const Privilege = "userPrivilegeModel";
const IsSMRTNonCFOUser = "isSMRTNonCFOUser";
const IsAdmin = "IsAdmin";
const Merchant = "Merchant";
const UserAuthenticatedTime = "UserAuthenticatedTime";
const NeedChangePassword = "NeedChangePassword";
const TemporaryPassword = "TemporaryPassword";
const MerchantId = "merchantId";
const UserRole = "userRole";
const MerchantName = "merchantName";
const MobileNum = "mobileNum";

const sessionManager = {};

sessionManager.setMenuList = function (val) {
    localStorage.setItem(MenuList, JSON.stringify(val))
}

sessionManager.getMenuList = function () {
    let menu = localStorage.getItem(MenuList)
    if(!menu){
        return ""
    }
    return JSON.parse(menu)
}

sessionManager.setUserInfo = function (val) {
    localStorage.setItem(UserInfoKey, JSON.stringify(val));
}
sessionManager.getUserInfo = function () {
    let user = localStorage.getItem(UserInfoKey)
    if(!user){
        return ""
    }
    return JSON.parse(user);
}

sessionManager.setPermission = function (val) {
    localStorage.setItem(PermissionKey, JSON.stringify(val));
}
sessionManager.getPermission = function () {
    let permission = localStorage.getItem(PermissionKey)
    if(!permission){
        return ""
    }
    return JSON.parse(permission);
}

sessionManager.setToken = function (val) {
    localStorage.setItem(TokenKey, val);
}

sessionManager.getToken = function () {
    return localStorage.getItem(TokenKey);
}

sessionManager.setRefreshToken = function (val) {
    localStorage.setItem(RefreshTokenKey, val);
}

sessionManager.getRefreshToken = function () {
    return localStorage.getItem(RefreshTokenKey);
}

sessionManager.setUserId = function (val) {
    localStorage.setItem(UserId, val);
}

sessionManager.getUserId = function () {
    return localStorage.getItem(UserId);
}

sessionManager.setUserRole = function (val) {
    localStorage.setItem(UserRole, val);
}

sessionManager.getUserRole = function () {
    return localStorage.getItem(UserRole);
}

sessionManager.setMerchantId = function (val) {
    localStorage.setItem(MerchantId, val);
}

sessionManager.getMerchantId = function () {
    return localStorage.getItem(MerchantId);
}

sessionManager.setMerchantName = function (val) {
    localStorage.setItem(MerchantName, val);
}

sessionManager.getMerchantName = function () {
    return localStorage.getItem(MerchantName);
}

sessionManager.setPrivilege = function (val) {
    localStorage.setItem(Privilege, JSON.stringify(val));
}
sessionManager.getPrivilege = function () {
    let privilege = localStorage.getItem(Privilege)
    if(!privilege){
        return ""
    }
    return JSON.parse(privilege);
}

sessionManager.setIsSMRTNonCFOUser = function (val) {
    localStorage.setItem(IsSMRTNonCFOUser, val)
}

sessionManager.getIsSMRTNonCFOUser = function(){
    localStorage.getItem(IsSMRTNonCFOUser)
}

sessionManager.setIsAdmin = function (val) {
    localStorage.setItem(IsAdmin, val)
}

sessionManager.getIsAdmin = function () {
    localStorage.getItem(IsAdmin)
}

sessionManager.setMerchant = function (val) {
    localStorage.setItem(Merchant, val)
}

sessionManager.getMerchant = function () {
    localStorage.getItem(Merchant)
}

sessionManager.setUserAuthenticatedTime = function (val) {
    localStorage.setItem(UserAuthenticatedTime, val)
}

sessionManager.getUserAuthenticatedTime = function () {
    localStorage.getItem(UserAuthenticatedTime)
}

sessionManager.setNeedChangePassword = function (val) {
    localStorage.setItem(NeedChangePassword, val)
}

sessionManager.getNeedChangePassword = function () {
    localStorage.getItem(NeedChangePassword)
}

sessionManager.setTemporaryPassword = function (val) {
    localStorage.setItem(TemporaryPassword, val)
}

sessionManager.getTemporaryPassword = function () {
    localStorage.getItem(TemporaryPassword)
}

sessionManager.isLogin = function () {

};

sessionManager.signout = function () {
    localStorage.clear();
}

sessionManager.setMobileNum = function (val) {
    localStorage.setItem(MobileNum, val);
}

sessionManager.getMobileNum = function () {
    return localStorage.getItem(MobileNum);
}


export { sessionManager };
